import { render, staticRenderFns } from "./Subscriptions.vue?vue&type=template&id=65c617d0&"
import script from "./Subscriptions.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Subscriptions.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports